module.exports = __webpack_public_path__ + "img/472c472.png";